import React from "react"
import axios from "axios"
import { Form, Formik } from "formik"
import { useOrder } from "context/order"
import { useLocale } from "context/locale"
import { navigate } from "gatsby"
import * as Yup from "yup"
import OrderNav from "./components/OrderNav"
import StepFirst from "./components/StepFirst"
import StepSecond from "./components/StepSecond"
import StepThird from "./components/StepThird"
import StepFourth from "./components/StepFourth"
import StepFifth from "./components/StepFifth"
import post_codes from "../post_codes"

import StyledOrderCourierForm from "./styles"

const initial_values = {
  order_type: "",
  first_name: "",
  last_name: "",
  email: "",
  street: "",
  city: "",
  phone: "",
  province: "",
  postcode: "",
  boxes_amount: "",
  date: "",
  privacy_policy: false,
  data_transfer: false,
  anonymous: false,
}

const onKeyDown = e => {
  if ((e.charCode || e.keyCode) === 13) {
    e.preventDefault()
  }
}

const default_error = "Wystąpił błąd. Spróbuj ponownie później."

const OrderCourierForm = () => {
  const { t } = useLocale()
  const { show_form, step, setStep, serResError } = useOrder()

  const post_codes_arr = post_codes.map(({ code }) => code)

  const validation_schema = [
    Yup.object().shape({
      order_type: Yup.string().required(t("Choose a delivery method")),
    }),
    Yup.object().shape({
      first_name: Yup.string().required(t("Podaj swoje imię")),
      last_name: Yup.string().required(t("Podaj nazwisko")),
      email: Yup.string()
        .email(t("Niepoprawny format"))
        .required(t("Podaj adres email")),
      street: Yup.string().required(t("Podaj swój adres zamieszkania")),
      city: Yup.string().required(t("Podaj miasto zamieszkania")),
      phone: Yup.string()
        .required(t("Podaj numer telefonu"))
        .matches(/^[0-9]+$/, t("Niepoprawny format"))
        .min(9, t("Minimum 9 znaków")),
      province: Yup.string().required(t("Podaj województwo")),
      postcode: Yup.string()
        .required(t("Podaj kod pocztowy"))
        .matches(/\d{2}-\d{3}/, t("Niepoprawny format"))
        .test(
          "post-codes",
          t(
            "Ten rejon nie jest obsługiwany:( Prosimy o kontakt: kontakt@ubraniadooddania.pl)"
          ),
          function (value) {
            return post_codes_arr.includes(value)
          }
        ),
    }),
    Yup.object().shape({
      boxes_amount: Yup.number()
        .required(t("Nie podałeś ilości kartonów"))
        .min(1, t("Ilość musi być większa od zera")),
    }),
    Yup.object().shape({
      date: Yup.string().required(t("Wybierz datę odbioru paczki")),
    }),
    Yup.object().shape({
      privacy_policy: Yup.bool().oneOf([true], t("Pole wymagane")),
      // data_transfer: Yup.bool().oneOf([true], t("Pole wymagane")),
      anonymous: Yup.bool().oneOf([true], t("Pole wymagane")),
    }),
  ]

  return (
    <StyledOrderCourierForm id="order_form" show_form={show_form}>
      <div className="main-container">
        <div className="order-courier-form__wrapper">
          <h2 className="order-courier-form__header">
            {t("Fill in the form")}
          </h2>
          <OrderNav />
          <Formik
            initialValues={initial_values}
            validationSchema={validation_schema[step - 1]}
            onSubmit={async (values, { setSubmitting, resetForm }) => {
              try {
                setSubmitting(false)
                const res = await axios.post(
                  process.env.GATSBY_ORDER_ENDPOINT,
                  values
                )
                if (res?.data?.response.code > 300) {
                  const json_body = JSON.parse(res.data.body)
                  serResError(json_body?.error || default_error)
                } else {
                  serResError(null)
                  setStep(1)
                  resetForm()
                  navigate("/potwierdzenie/")
                }
              } catch (error) {
                console.log(error)
                serResError(default_error)
              }
            }}
          >
            {() => (
              <Form
                className="order-courier-form__content"
                onKeyDown={onKeyDown}
                noValidate
              >
                <StepFirst />
                <StepSecond />
                <StepThird />
                <StepFourth />
                <StepFifth />
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </StyledOrderCourierForm>
  )
}

export default OrderCourierForm
